export enum ExportFormat {
  JSON = 'json',
  CSV = 'csv',
  BOTH = 'both',
}

export type ExportFileFormat = ExportFormat.JSON | ExportFormat.CSV;

export type ExportableData = any;

export interface ExportConfig {
  fileName: string;
  format: ExportFileFormat;
  date?: boolean;
  preserveTimestamp?: boolean;
}

export interface ExportDataSource {
  key: string;
  label: string;
  data: ExportableData;
  fileName?: string;
}
